import React from 'react';
import Heading from 'app_previous/elements/typography/heading';
import { AboutTitleHeading } from './TitleHeading.styles';
import { HeadlineAvailableFontSizes } from 'app_previous/elements/typography/heading.styles';

interface TitleHeadingProps {
  title: string;
  color?: string;
  size?: HeadlineAvailableFontSizes;
}

const TitleHeading = ({ title, color, size }: TitleHeadingProps): JSX.Element => {
  return (
    <AboutTitleHeading className='title-heading'>
      <Heading
        text={title}
        size={size ?? '1.5rem'}
        align='center'
        color={color}
      />
    </AboutTitleHeading>
  );
};

export default TitleHeading;
